const state = {
  nav: [],
  selectedTab: "",
  patientRef: null,
  canManagePatient: false, // for physician login (datepicker state),
};

export default state;
